import { render, staticRenderFns } from "./WsInfoText.vue?vue&type=template&id=0777edc0"
import script from "./WsInfoText.vue?vue&type=script&lang=js"
export * from "./WsInfoText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports